
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface CTASectionProps {
  onTechstarsClick: () => void;
  onOtherClick: () => void;
}

const CTASection = ({ onTechstarsClick, onOtherClick }: CTASectionProps) => {
  return (
    <section className="container mx-auto px-6 py-20">
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-12 text-center text-white">
        <h2 className="text-4xl font-bold mb-4">Ready to Accelerate Your Fundraising?</h2>
        <p className="text-xl mb-8 opacity-90">
          Join hundreds of accelerator startups who've saved time and closed faster with ScoutLink.ai
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size="lg" 
            variant="secondary" 
            className="text-lg px-8 py-4"
            onClick={onTechstarsClick}
          >
            Apply Now - Techstars
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="text-lg px-8 py-4 text-white border-white hover:bg-white hover:text-gray-900"
            onClick={onOtherClick}
          >
            Apply Now - Other Accelerators
          </Button>
        </div>
        
        <div className="mt-8 pt-8 border-t border-white/20">
          <p className="text-sm opacity-75">
            Not part of an accelerator? Contact us at{" "}
            <a href="mailto:hello@scoutlink.ai" className="underline hover:no-underline">
              hello@scoutlink.ai
            </a>{" "}
            for enterprise inquiries.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
